import {
  FAILED_GET_PACKAGE,
  FAILED_GET_PACKAGES,
  FAILED_PERSIST_PACKAGE,
  RECEIVE_GET_PACKAGE,
  RECEIVE_GET_PACKAGES,
  RECEIVE_PERSIST_PACKAGE,
  REQUEST_PERSIST_PACKAGE,
} from 'redux/actions/package'
import {RESET_STATE} from 'redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_PACKAGE:
    case FAILED_PERSIST_PACKAGE:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        }
      }
    case RECEIVE_PERSIST_PACKAGE:
    case RECEIVE_GET_PACKAGE:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        }
      }
    case RECEIVE_GET_PACKAGES:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        }
      }
    case REQUEST_PERSIST_PACKAGE:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true
        }
      }
    case RESET_STATE:
      if (action.state === 'package') {
        return {
          ...state,
          [action.screen]: initialState[action.screen]
        }
      }
    default:
      return state
  }
}
